/** 盘点读取需重新核实版本；写入重试由服务端幂等回执处理，不能复用刚结束的响应。 */
export const COUNT_SESSION_MERGE_EXCLUSION = /(?:^|\/)merchant\/wms\/counts(?:\/|\?|$)/
